import HoverMenu from 'ats/components/hover-menu/HoverMenu';
import UserProfileAvatar from 'ats/components/user-profile-avatar/UserProfileAvatar';
import { JobApplicationHistoryEdit } from 'ats/pages/pipeline/components/JobApplicationHistoryEdit';
import { jobApplicationStore } from 'ats/pages/pipeline/components/JobApplicationStore';
import { modalStore } from 'components/layout/modals/ModalStore';
import moment from 'moment';
import React, { useState } from 'react';
import useIsClamped from 'ats/hooks/useIsClamped';
import { formatTimeAgo } from 'shared/utils';
import JobApplicationStageLabel from 'ats/pages/pipeline/components/JobApplicationStageLabel';
import LinkifyText from 'ats/components/linkify-text/LinkifyText';

export default function JobApplicationHistoryCard({ history, onSuccess }) {
	const [showMore, setShowMore] = useState(false);
	const [descriptionRef, isClamped] = useIsClamped(
		history?.description,
		!showMore
	);

	const getStage = value =>
		jobApplicationStore.stageOptions.find(stage => stage.value === value);

	const getStatus = value =>
		jobApplicationStore.statusOptions.find(status => status.value === value);

	const stageData = getStage(history?.newValue);
	const statusData = getStatus(
		jobApplicationStore.stageToStatus[history?.newValue]
	);

	const handleHistoryEdit = history => {
		modalStore.openModal(
			{ title: 'Update History', size: 'xl', position: 'center' },
			<JobApplicationHistoryEdit
				jobApplicationId={history.jobApplicationId}
				history={history}
				handleSuccess={async () => {
					onSuccess?.();
				}}
			/>
		);
	};

	const getMenuItems = history => [
		{
			label: `${history?.description ? 'Edit' : 'Add'} Comment`,
			img: '/ats/icons/edit-icon.svg',
			onClick: () => handleHistoryEdit(history)
		}
	];

	return (
		<div className="job-position-history-card">
			<div className="history-card-info-container">
				<div className="history-card-info actions is-flex-grow-1">
					<span className="history-info-new-value">
						<JobApplicationStageLabel
							stageData={stageData}
							statusData={statusData}
							showStatusTooltip
						/>
						{history?.filledVacancyId && (
							<span className="history-info-filled-vacancy">
								Vacancy ID: #{history?.filledVacancyId}
							</span>
						)}
					</span>
					<span className="history-info-updated-by ml-auto">
						<UserProfileAvatar
							imageUrl={history?.updatedBy?.imageUrl}
							name={history?.updatedBy?.name}
						/>
						{moment().diff(moment(history?.updatedAt), 'days', true) > 1
							? moment(history?.updatedAt).format('lll')
							: formatTimeAgo(new Date(history?.updatedAt))}
					</span>
					<HoverMenu
						id={history.id}
						position="left"
						buttonIcon={
							<img src="/ats/icons/three-dots-icon.svg" alt="Menu button" />
						}
						items={getMenuItems(history)}
					/>
				</div>
			</div>
			{history?.description && (
				<div className="history-card-description">
					<p
						ref={descriptionRef}
						className={showMore ? undefined : 'is-clamped'}>
						<LinkifyText text={history?.description} />
					</p>
					{showMore && history?.descriptionUpdatedBy?.id && (
						<div className="history-card-description-commented-by">
							Commented by
							<UserProfileAvatar
								imageUrl={history?.descriptionUpdatedBy?.imageUrl}
								name={history?.descriptionUpdatedBy?.name}
								showName
							/>{' '}
							at{' '}
							{formatTimeAgo(new Date(history?.descriptionUpdatedAt), {
								moreThanOneDay: true
							})}
						</div>
					)}
					{(showMore || isClamped) && (
						<button onClick={() => setShowMore(!showMore)}>
							{showMore ? 'View Less' : 'View More'}
						</button>
					)}
				</div>
			)}
		</div>
	);
}
